<template>
  <div class="requisitos container">
    <AlertaMsj :alerta-msj="alertaMsj" />
    <header class="h2-responsive mt-3 font-weight-bold text-center">
      Requisitos
    </header>
    <div class="row justify-content-around">
      <div
        v-for="modul in modules"
        :key="modul.name"
        class="col-12 col-sm-11 col-xl-6 py-3 text-center"
      >
        <mdb-card>
          <mdb-card-body>
            <mdb-card-title>
              Documentos requeridos en {{ modul.name }}
            </mdb-card-title>
            <div class="container">
              <div class="row align-items-center justify-content-center">
                <div class="col-12 col-sm">
                  <div class="md-form md-outline outline-select my-1">
                    <select
                      :id="modul.name + '-select'"
                      v-model="requirement.req"
                      class="custom-select custom-select-sm"
                    >
                      <option
                        class="d-none"
                        :value="{name: ''}"
                        disabled
                      >
                        Seleccione
                      </option>
                      <option
                        v-for="req in requirements"
                        :key="req.name"
                        :value="req"
                      >
                        {{ req.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <mdb-btn
                  class="col-auto"
                  color="primary"
                  icon="file-medical"
                  size="sm"
                  :disabled="btnDisabled"
                  @click="requirementModuleAdd(modul)"
                >
                  Agregar a {{ modul.name }}
                </mdb-btn>
              </div>
              <ul class="requirement-list">
                <li
                  v-for="req in modul.requirements"
                  :key="req.name"
                >
                  <Documento
                    v-if="req.name"
                    :requirement="req"
                  >
                    <template v-slot:botones>
                      <mdb-btn
                        flat
                        dark-waves
                        text="danger"
                        icon="minus-circle"
                        title="Eliminar"
                        class="ml-0"
                        @click="showConfirmation = true;requirement={
                          req,
                          modName:modul.name,
                        }"
                      />
                    </template>
                  </Documento>
                </li>
              </ul>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>
    </div>
    <!--
      Modal para confirmar la
      eliminación de un documento
    -->
    <mdb-modal
      class="be-bottom"
      direction="bottom"
      :show="showConfirmation"
      @close="showConfirmation = false"
    >
      <mdb-modal-body class="delete-document">
        <p class="my-2">
          ¿Está seguro que desea eliminar el documento
          <span class="font-weight-bold">
            {{ requirement.req.name }}
          </span> de este módulo?
        </p>
        <div class="buttons">
          <mdb-btn
            class="order-2 order-sm-1"
            color="blue-grey"
            icon="times"
            :disabled="btnDisabled"
            @click="showConfirmation = false"
          >
            Cancelar
          </mdb-btn>
          <mdb-btn
            class="order-1 order-sm-2"
            color="danger"
            icon="minus-circle"
            @click="requirementModuleDelete()"
          >
            Eliminar
          </mdb-btn>
        </div>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>
<script>
import Documento from '../components/Documento.vue';
import AlertaMsj from '../components/AlertaMsj.vue';
import {mdbModal, mdbModalBody, mdbBtn,
  mdbCard, mdbCardBody, mdbCardTitle} from 'mdbvue';
import gql from 'graphql-tag';
import moduleGql from '../graphql/module.gql';
import requirementsGql from '../graphql/requirements.gql';
import requirementModuleAddGql from '../graphql/requirementModuleAdd.gql';
import requirementModuleDeleteGql from '../graphql/requirementModuleDelete.gql';
export default {
  name: 'Requisitos',
  components: {
    Documento,
    AlertaMsj,
    mdbBtn,
    mdbModal,
    mdbModalBody,
    mdbCard,
    mdbCardBody,
    mdbCardTitle,
  },
  data() {
    return {
      showConfirmation: false,
      requirement: {req: {name: ''}},
      alertaMsj: {
        content: '',
      },
      btnDisabled: false,
    };
  },
  apollo: {
    modules() {
      return {
        query: gql`${moduleGql}`,
        update: (data) => data.Module,
      };
    },
    requirements() {
      return {
        query: gql`${requirementsGql}`,
        update: (data) => data.Requirement,
      };
    },
  },
  methods: {
    requirementModuleAdd(modulo) {
      if (!this.requirement.req.name) {
        return this.alertaMsj = {
          content: 'Elige un requisito para agregar al modulo',
          type: 'warning',
        };
      }
      this.btnDisabled = true;
      this.$apollo.mutate({
        mutation: gql`${requirementModuleAddGql}`,
        variables: {
          reqName: this.requirement.req.name,
          modName: modulo.name,
        },
      }).then((res) => {
        this.requirement.name = false;
        modulo.requirements.push(JSON.parse(
            JSON.stringify(this.requirement.req
            )));
        this.btnDisabled = false;
        this.alertaMsj = {
          content: 'Documento agregado al módulo con éxito',
          type: 'success',
        };
      }).catch((error) => {
        this.btnDisabled = false;
        this.alertaMsj = {
          content: 'Hubo un error al agregar el documento',
          type: 'danger',
        };
      });
    },
    requirementModuleDelete() {
      this.btnDisabled = true;
      this.$apollo.mutate({
        mutation: gql`${requirementModuleDeleteGql}`,
        variables: {
          reqName: this.requirement.req.name,
          modName: this.requirement.modName,
        },
      }).then((res) => {
        this.requirement.req.name = false;
        this.btnDisabled = false;
        this.alertaMsj = {
          content: 'Documento removido del módulo con éxito',
          type: 'success',
        };
      }).catch((error) => {
        this.btnDisabled = false;
        this.responseMsg = {
          content: 'Hubo un error al eliminar el documento',
          type: 'danger',
        };
      });
      this.showConfirmation = false;
    },
  },
};
</script>
<style lang="scss">
  .be-bottom .modal-dialog {
    bottom: 0;
    margin: 1.75rem auto 0;
    max-width: 100%;
    position: fixed;
    width: 100%;

    .delete-document {
      align-items: center;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;

      .buttons {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
      }
    }
  }
</style>
